import React from 'react';
import Icon from '../../../components/AppIcon';

const ValueProposition = () => {
  const benefits = [
    {
      icon: "Save",
      title: "Save Your Trips",
      description: "Keep all your planned adventures in one secure place"
    },
    {
      icon: "History",
      title: "Trip History",
      description: "Access your past trips and favorite destinations anytime"
    },
    {
      icon: "Target",
      title: "Personalized Recommendations",
      description: "Get AI-powered suggestions based on your preferences"
    },
    {
      icon: "Share2",
      title: "Share & Collaborate",
      description: "Share trip plans with family and friends easily"
    },
    {
      icon: "Calendar",
      title: "Trip Management",
      description: "Edit, update, and organize your travel plans"
    },
    {
      icon: "Bell",
      title: "Smart Notifications",
      description: "Get reminders and updates about your upcoming trips"
    }
  ];

  return (
    <div className="bg-white/95 backdrop-blur-sm rounded-organic p-6 space-y-6 shadow-organic-lg">
      <div className="text-center space-y-2">
        <h3 className="text-xl font-heading font-heading-bold text-foreground">
          Why Create an Account?
        </h3>
        <p className="font-body text-base text-muted-foreground">
          Unlock the full potential of ParkTrip Planner AI with your free account
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-organic-sm flex items-center justify-center">
              <Icon name={benefit?.icon} size={16} className="text-primary" />
            </div>
            <div className="space-y-1">
              <h4 className="text-sm font-body font-body-medium text-foreground">
                {benefit?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-background border border-border rounded-organic-sm p-4">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Shield" size={16} className="text-success" />
          <span className="text-sm font-body font-body-medium text-foreground">
            Your Data is Secure
          </span>
        </div>
        <p className="text-xs text-muted-foreground leading-relaxed">
          We use industry-standard encryption to protect your personal information. 
          Your trip data is private and will never be shared without your consent.
        </p>
      </div>
    </div>
  );
};

export default ValueProposition;